import { Branch, Cast, Endpoint, Node, Realm, Syndicate } from '@xanadu/model';
import { ImportMenu } from './import-menu';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ImportMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): ImportMenu {
        const menu = new ImportMenu();
        if (node instanceof Realm) {
            this.forRealm(menu, node);
        } else if (node instanceof Endpoint) {
            this.forEndpoint(menu, node);
        } else if (node instanceof Syndicate) {
            this.forSyndicate(menu, node);
        } else if (node instanceof Cast) {
            this.forCast(menu, node);
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forRealm(menu: ImportMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.realm = true;
        menu.endpoint = true;
    }

    private forEndpoint(menu: ImportMenu, node: Node): void {
    }

    private forSyndicate(menu: ImportMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.syndicate = true;
        menu.cast = true;
    }

    private forCast(menu: ImportMenu, node: Node): void {
    }

    private forEdit(menu: ImportMenu, node: Node, clipboard: Node): void {
        menu.delete = !!node.parentId && (!(node instanceof Branch) || !node.nodes?.length && !node.branches?.length);
        menu.cut = !!node.parentId;
        menu.copy = !!node.parentId && (!(node instanceof Realm) || !(node instanceof Syndicate));
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && !node.isNew;
    }
}
